import helpers from '../helpers/helpers';
export default {
  modelName: 'user_factory_template_role',
  label: '預設工廠角色管理',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    is_active: {
      type: 'switch',
      label: '',
      defaultValue: true,
      activeText: '顯示',
      inactiveText: '隱藏',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '角色名稱',
          rules: 'required',
        },
      },
    },
    name: {
      type: 'text',
      label: '角色名稱',
      rules: 'required',
    },
    factory: {
      type: 'factory',
      label: '適用工廠',
      fields: {
        name: {
          label: '適用工廠',
          type: 'text',
        },
      },
    },
    factories: {
      label: '適用工廠',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'factory',
      orderBy: 'no_number',
      orderWay: 'asc',
      noReset: true,
      hasCloseChips: true,
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item);
      },
      displayCheck: (modelData) => {
        return modelData.is_default !== undefined
          ? modelData.is_default
          : modelData.factories !== undefined
          ? true
          : modelData.is_default;
      },
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
    tags: {
      label: '全域標籤設定',
      type: 'hasMany',
      inLocale: true,
      textKey: 'name',
      modelName: 'tag',
      // valueKey: "name"
    },
    is_default: {
      type: 'switch',
      label: '客製',
      defaultValue: true,
      activeText: '是',
      inactiveText: '否',
    },
    dashboard: {
      type: 'checkbox',
      label: '概況',
      items: [
        {
          value: ['dashboard-read'],
          text: '瀏覽概況',
        },
      ],
    },
    parentDashboard: {
      type: 'checkbox',
      label: '集團概況',
      items: [
        {
          value: [
            'organization-dashboard-read',
          ],
          text: '瀏覽集團概況',
        },
        {
          value: [
            'factory-dashboard-read',
          ],
          text: '瀏覽各廠概況',
        },
      ],
    },
    broadcast: {
      type: 'checkbox',
      label: '快報',
      items: [
        {
          value: ['llbroadcast-read'],
          text: '瀏覽快報',
        },
      ],
    },
    acts: {
      type: 'checkbox',
      label: '法規法條',
      multipleValue: true,
      items: [
        {
          value: ['act-read'],
          text: '瀏覽法規',
        },
        {
          value: ['act-inquiry'],
          text: '法律諮詢',
        },
        {
          value: ['act-update-factory-tag'],
          text: '法律添加標籤',
        },
      ],
    },
    alert: {
      type: 'checkbox',
      label: '警示',
      multipleValue: true,
      items: [
        {
          value: ['alert-read'],
          text: '瀏覽警示(將收到警示通知)',
        },
        {
          value: ['alert-slove'],
          text: '排除/復原警示',
        },
      ],
    },
    task: {
      type: 'checkbox',
      label: '任務',
      multipleValue: true,
      items: [
        {
          value: ['task-read'],
          text: '瀏覽任務',
        },
        {
          value: ['task-read-all'],
          text: '瀏覽全廠的任務及待辦',
        },
        {
          value: ['task-create'],
          text: '新增任務',
        },
        {
          value: ['task-update-creator'],
          text: '編輯我建立的任務',
        },
        {
          value: ['task-update-taker'],
          text: '編輯我負責的任務',
        },
        {
          value: ['task-update'],
          text: '編輯全廠的任務',
        },
        {
          value: ['task-check-taker'],
          text: '審核我負責的任務',
        },
        {
          value: ['task-delete-creator'],
          text: '刪除我建立的任務',
        },
        {
          value: ['task-delete-taker'],
          text: '刪除我負責的任務',
        },
        {
          value: ['task-delete'],
          text: '刪除全廠的任務',
        },
      ],
    },
    taskTemplate: {
      type: 'checkbox',
      label: '任務公版',
      multipleValue: true,
      items: [
        {
          value: ['task-factory-template-read'],
          text: '瀏覽任務公版',
        },
        {
          value: ['task-factory-template-create'],
          text: '新增任務公版',
        },
        {
          value: ['task-factory-template-update'],
          text: '編輯任務公版',
        },
        {
          value: ['task-factory-template-destory'],
          text: '刪除任務公版',
        },
      ],
    },
    contractor: {
      type: 'checkbox',
      label: '承攬商',
      multipleValue: true,
      items: [
        {
          value: ['contractor-read'],
          text: '瀏覽承攬商',
        },
        {
          value: ['contractor-create'],
          text: '新增承攬商',
        },
        {
          value: ['contractor-update-creator'],
          text: '編輯我建立的承攬商',
        },
        {
          value: ['contractor-update-owner'],
          text: '編輯我負責的承攬商',
        },
        {
          value: ['contractor-update'],
          text: '編輯全廠的承攬商',
        },
        {
          value: ['contractor-delete-creator'],
          text: '刪除我建立的承攬商',
        },
        {
          value: ['contractor-delete-owner'],
          text: '刪除我負責的承攬商',
        },
        {
          value: ['contractor-delete'],
          text: '刪除全廠的承攬商',
        },
        {
          value: ['contractor-license-read'],
          text: '瀏覽承攬商資格證',
        },
        {
          value: ['contractor-license-create'],
          text: '新增承攬商資格證',
        },
        {
          value: ['contractor-license-update-creator'],
          text: '編輯我建立的承攬商資格證',
        },
        {
          value: ['contractor-license-update-reminder'],
          text: '編輯我負責的承攬商資格證',
        },
        {
          value: ['contractor-license-update'],
          text: '編輯全廠的承攬商資格證',
        },
        {
          value: ['contractor-license-delete-creator'],
          text: '刪除我建立的承攬商資格證',
        },
        {
          value: ['contractor-license-delete-reminder'],
          text: '刪除我負責的承攬商資格證',
        },
        {
          value: ['contractor-license-delete'],
          text: '刪除全廠的承攬商資格證',
        },
        {
          value: ['contract-read'],
          text: '瀏覽承攬商契約',
        },
        {
          value: ['contract-create'],
          text: '新增承攬商契約',
        },
        {
          value: ['contract-update-creator'],
          text: '編輯我建立的承攬商契約',
        },
        {
          value: ['contract-update-owner'],
          text: '編輯我負責的承攬商契約',
        },
        {
          value: ['contract-update'],
          text: '編輯全廠的承攬商契約',
        },
        {
          value: ['contract-delete-creator'],
          text: '刪除我建立的承攬商契約',
        },
        {
          value: ['contract-delete-owner'],
          text: '刪除我負責的承攬商契約',
        },
        {
          value: ['contract-delete'],
          text: '刪除全廠的承攬商契約',
        },
      ],
    },
    license: {
      type: 'checkbox',
      label: '證照',
      multipleValue: true,
      items: [
        {
          value: ['license-read'],
          text: '瀏覽證照',
        },
        {
          value: ['license-create'],
          text: '新增證照',
        },
        {
          value: ['license-update-creator'],
          text: '編輯我建立的證照',
        },
        {
          value: ['license-update-reminder'],
          text: '編輯我管理的證照',
        },
        {
          value: ['license-update'],
          text: '編輯全廠的證照',
        },
        {
          value: ['license-delete-creator'],
          text: '刪除我建立的證照',
        },
        {
          value: ['license-delete-reminder'],
          text: '刪除我管理的證照',
        },
        {
          value: ['license-delete'],
          text: '刪除全廠的證照',
        },
      ],
    },
    training: {
      type: 'checkbox',
      label: '教育訓練',
      multipleValue: true,
      items: [
        {
          value: ['internal-training-read'],
          text: '瀏覽教育訓練',
        },
        {
          value: ['internal-training-create'],
          text: '新增教育訓練',
        },
        {
          value: ['internal-training-update-creator'],
          text: '編輯我建立的教育訓練',
        },
        {
          value: ['internal-training-update-principal'],
          text: '編輯我負責的教育訓練',
        },
        {
          value: ['internal-training-update'],
          text: '編輯全廠的教育訓練',
        },
        {
          value: ['internal-training-delete-creator'],
          text: '刪除我建立的教育訓練',
        },
        {
          value: ['internal-training-delete-principal'],
          text: '刪除我負責的教育訓練',
        },
        {
          value: ['internal-training-delete'],
          text: '刪除全廠的教育訓練',
        },
      ],
    },
    event: {
      type: 'checkbox',
      label: '風險事件',
      multipleValue: true,
      items: [
        {
          value: ['event-read'],
          text: '瀏覽風險事件',
        },
        {
          value: ['event-create'],
          text: '新增風險事件',
        },
        {
          value: ['event-update-creator'],
          text: '編輯我建立的風險事件',
        },
        {
          value: ['event-update-owner'],
          text: '編輯我負責的風險事件',
        },
        {
          value: ['event-update'],
          text: '編輯全廠的風險事件',
        },
        {
          value: ['event-delete-creator'],
          text: '刪除我建立的風險事件',
        },
        {
          value: ['event-delete-owner'],
          text: '刪除我負責的風險事件',
        },
        {
          value: ['event-delete'],
          text: '刪除全廠的風險事件',
        },
      ],
    },
    contractorEnterRecord: {
      type: 'checkbox',
      label: '進廠管理',
      multipleValue: true,
      items: [
        {
          value: ['contractor-enter-record-read'],
          text: '瀏覽進廠管理',
        },
        {
          value: ['contractor-enter-record-create'],
          text: '新增進廠管理',
        },
        {
          value: ['contractor-enter-record-update-creator'],
          text: '編輯我建立的進廠紀錄',
        },
        {
          value: ['contractor-enter-record-update-owner'],
          text: '編輯我負責的進廠紀錄',
        },
        {
          value: ['contractor-enter-record-update'],
          text: '編輯全廠的進廠紀錄',
        },
        {
          value: ['contractor-enter-record-delete-creator'],
          text: '刪除我建立的進廠紀錄',
        },
        {
          value: ['contractor-enter-record-delete-owner'],
          text: '刪除我負責的進廠紀錄',
        },
        {
          value: ['contractor-enter-record-delete'],
          text: '刪除全廠的進廠紀錄',
        },
        {
          value: ['exit-checklist'],
          text: '收工檢查作業：當我是進廠紀錄負責人時，可進行收工檢查作業',
        },
      ],
    },
    audit: {
      type: 'checkbox',
      label: '稽核管理',
      multipleValue: true,
      items: [
        {
          value: ['audit-read'],
          text: '瀏覽稽核表、稽核紀錄',
        },
        {
          value: ['audit-create'],
          text: '新增稽核表、稽核紀錄',
        },
        {
          value: ['audit-update-creator'],
          text: '編輯我建立的稽核表',
        },
        {
          value: ['audit-update-owner'],
          text: '編輯我管理的稽核表',
        },
        {
          value: ['audit-update'],
          text: '編輯全廠的稽核表',
        },
        {
          value: ['audit-delete-creator'],
          text: '刪除我建立的稽核表',
        },
        {
          value: ['audit-delete-owner'],
          text: '刪除我管理的稽核表',
        },
        {
          value: ['audit-delete'],
          text: '刪除全廠的稽核表',
        },
        {
          value: ['audit-record'],
          text: '稽核作業：當我是稽核者時，可進行稽核作業',
        },
        {
          value: ['auditee-record'],
          text: '受稽作業：當我是受稽者時，可瀏覽預定受稽行程、回覆稽核結果',
        },
      ],
    },
    checklist: {
      type: 'checkbox',
      label: '日常自檢',
      multipleValue: true,
      items: [
        {
          value: ['checklist-read'],
          text: '瀏覽點檢表、點檢紀錄',
        },
        {
          value: ['checklist-create'],
          text: '新增點檢表',
        },
        {
          value: ['checklist-update-creator'],
          text: '編輯我建立的點檢表',
        },
        {
          value: ['checklist-update-owner'],
          text: '編輯我管理的點檢表',
        },
        {
          value: ['checklist-update'],
          text: '編輯全廠的點檢表',
        },
        {
          value: ['checklist-delete-creator'],
          text: '刪除我建立的點檢表',
        },
        {
          value: ['checklist-delete-owner'],
          text: '刪除我管理的點檢表',
        },
        {
          value: ['checklist-delete'],
          text: '刪除全廠的點檢表',
        },
        {
          value: ['checklist-record-checker'],
          text: '點檢作業：當我是填表者時，可進行點檢作業、瀏覽被覆核結果',
        },
        {
          value: ['checklist-record-manager'],
          text: '點檢作業(不須為填表者)：可對全廠任一點檢表進行點檢作業、瀏覽全廠點檢表',
        },
        {
          value: ['checklist-review-record'],
          text: '覆核作業：當我是覆核者時，可覆核點檢結果、瀏覽覆核結果',
        },
        {
          value: ['checklist-sample-record'],
          text: '抽檢作業：可對全廠點檢結果進行抽檢',
        },
      ],
    },
    commonChoice: {
      type: 'checkbox',
      label: '自訂常用選項',
      multipleValue: true,
      items: [
        {
          value: ['common-choice-read'],
          text: '瀏覽自訂常用選項',
        },
        {
          value: ['common-choice-create'],
          text: '新增自訂常用選項',
        },
        {
          value: ['common-choice-update-owner'],
          text: '編輯我的自訂常用選項',
        },
        {
          value: ['common-choice-update'],
          text: '編輯全廠的自訂常用選項',
        },
        {
          value: ['common-choice-destroy-owner'],
          text: '刪除我的自訂常用選項',
        },
        {
          value: ['common-choice-destroy'],
          text: '刪除全廠的自訂常用選項',
        },
      ],
    },
    changeManagement: {
      type: 'checkbox',
      label: '變動管理',
      multipleValue: true,
      items: [
        {
          value: ['change-read'],
          text: '瀏覽變動計畫',
        },
        {
          value: ['change-create'],
          text: '新增變動計畫',
        },
        {
          value: ['change-update-creator'],
          text: '編輯我建立的變動計畫',
        },
        {
          value: ['change-update-owner'],
          text: '編輯我負責的變動計畫',
        },
        {
          value: ['change-update'],
          text: '編輯全廠的變動計畫',
        },
        {
          value: ['change-delete-creator'],
          text: '刪除我建立的變動計畫',
        },
        {
          value: ['change-delete-owner'],
          text: '刪除我負責的變動計畫',
        },
        {
          value: ['change-delete'],
          text: '刪除全廠的變動計畫',
        },
        {
          value: ['change-record'],
          text: '變動計畫風險評估作業：當我是評估人員時，可進行風險評估作業、瀏覽評估結果',
        },
      ],
    },
    memberManagement: {
      type: 'checkbox',
      label: '成員管理',
      multipleValue: true,
      items: [
        {
          value: ['user-factory-manage'],
          text: '成員管理權限',
        },
      ],
    },
    roleManagement: {
      type: 'checkbox',
      label: '角色管理',
      multipleValue: true,
      items: [
        {
          value: ['role-read'],
          text: '瀏覽角色',
        },
        {
          value: ['role-create'],
          text: '新增角色',
        },
        {
          value: ['role-update-creator'],
          text: '編輯我建立的角色',
        },
        {
          value: ['role-update-owner'],
          text: '編輯我負責的角色',
        },
        {
          value: ['role-update'],
          text: '編輯全廠的角色',
        },
        {
          value: ['role-delete-creator'],
          text: '刪除我建立的角色',
        },
        {
          value: ['role-delete-owner'],
          text: '刪除我負責的角色',
        },
        {
          value: ['role-delete'],
          text: '刪除全廠的角色',
        },
      ],
    },
    factoryManagement: {
      type: 'checkbox',
      label: '工廠管理',
      multipleValue: true,
      items: [
        {
          value: ['factory-manage'],
          text: '工廠管理權限',
        },
      ],
    },
    sosRequest: {
      type: 'checkbox',
      label: 'SOS',
      multipleValue: true,
      items: [
        {
          value: ['sos-create'],
          text: '新增SOS',
        },
      ],
    },
    app: {
      type: 'checkbox',
      label: 'APP',
      multipleValue: true,
      items: [
        {
          value: ['app-apply'],
          text: 'APP使用',
        },
      ],
    },
    factoryTag: {
      type: 'checkbox',
      label: '工廠標籤',
      multipleValue: true,
      items: [
        {
          value: ['factory-tag-read'],
          text: '瀏覽工廠標籤',
        },
        {
          value: ['factory-tag-create'],
          text: '新增工廠標籤',
        },
        {
          value: ['factory-tag-update'],
          text: '編輯工廠標籤',
        },
        {
          value: ['factory-tag-delete'],
          text: '刪除工廠標籤',
        },
      ],
    },
    factoryEffect: {
      type: 'checkbox',
      label: '自訂風險',
      multipleValue: true,
      items: [
        {
          value: ['factory-effect-read'],
          text: '瀏覽自訂風險',
        },
        {
          value: ['factory-effect-create'],
          text: '新增自訂風險',
        },
        {
          value: ['factory-effect-update'],
          text: '編輯自訂風險',
        },
        {
          value: ['factory-effect-delete'],
          text: '刪除自訂風險',
        },
      ],
    },
    qrcode: {
      type: 'checkbox',
      label: 'QRcode工具',
      multipleValue: true,
      items: [
        {
          value: ['qrcode-read'],
          text: '瀏覽QRcode',
        },
        {
          value: ['qrcode-create'],
          text: '新增QRcode',
        },
        {
          value: ['qrcode-update'],
          text: '編輯全廠QRcode',
        },
        {
          value: ['qrcode-update-owner'],
          text: '編輯我管理的QRcode',
        },
        {
          value: ['qrcode-delete'],
          text: '刪除全廠QRcode',
        },
        {
          value: ['qrcode-delete-owner'],
          text: '刪除我管理的QRcode',
        },
      ],
    },
    file: {
      type: 'checkbox',
      label: '文件檔案庫',
      multipleValue: true,
      items: [
        {
          value: ['system-file-read'],
          text: '瀏覽系統資料夾及系統資料夾的檔案',
        },
        {
          value: ['system-file-delete'],
          text: '刪除系統檔案',
        },
        {
          value: ['first-folder-create'],
          text: '新增最上層資料夾',
        },
        {
          value: ['first-folder-update'],
          text: '編輯最上層資料夾',
        },
        {
          value: ['first-folder-delete'],
          text: '刪除最上層資料夾',
        },
        {
          value: ['other-folder-create'],
          text: '新增資料夾',
        },
        {
          value: ['other-folder-update'],
          text: '編輯資料夾',
        },
        {
          value: ['other-folder-delete'],
          text: '刪除資料夾',
        },
        {
          value: ['file-create'],
          text: '新增檔案',
        },
        {
          value: ['file-update'],
          text: '編輯檔案',
        },
        {
          value: ['file-delete'],
          text: '刪除檔案',
        },
      ],
    },
    agent: {
      type: 'checkbox',
      label: '代理人',
      multipleValue: true,
      items: [
        {
          value: ['job-agency-read'],
          text: '瀏覽全廠的代理人設定',
        },
        {
          value: ['job-agency-create'],
          text: '新增全廠的代理人設定',
        },
        {
          value: ['job-agency-update'],
          text: '編輯全廠的代理人設定',
        },
        {
          value: ['job-agency-delete'],
          text: '刪除全廠的代理人設定',
        },
      ],
    },
    guideline: {
      type: 'checkbox',
      label: '內規',
      multipleValue: true,
      items: [
        {
          value: ['guideline-read'],
          text: '瀏覽內規',
        },
        {
          value: ['guideline-history-read'],
          text: '瀏覽內規歷史版本+條文沿革',
        },
      ],
    },
    guidelineAdmin: {
      type: 'checkbox',
      label: '內規管理',
      multipleValue: true,
      items: [
        {
          value: ['guideline-admin-read'],
          text: '瀏覽內規管理',
        },
        {
          value: ['guideline-admin-create'],
          text: '新增內規 (包含內規施行狀態 crud)',
        },
        {
          value: ['guideline-admin-update-owner'],
          text: '編輯我負責的內規 (包含內規施行狀態 crud)',
        },
        {
          value: ['guideline-admin-update'],
          text: '編輯全廠的內規 (包含內規施行狀態 crud)',
        },
        {
          value: ['guideline-admin-destroy-owner'],
          text: '刪除我負責的內規',
        },
        {
          value: ['guideline-admin-destroy'],
          text: '刪除全廠的內規',
        },
        {
          value: ['guideline-admin-release'],
          text: '發布內規',
        },
      ],
    },
    translation: {
      type: 'checkbox',
      label: '自設文案',
      multipleValue: true,
      items: [
        {
          value: ['factory-translation-manage'],
          text: '自設文案管理權限',
        },
      ]
    },
    meeting: {
      type: 'checkbox',
      label: '議事',
      multipleValue: true,
      items: [
        {
          value: ['meeting-read'],
          text: '瀏覽議事',
        },
        {
          value: ['meeting-create'],
          text: '新增議事',
        },
        {
          value: ['meeting-update-owner'],
          text: '編輯我負責的議事',
        },
        {
          value: ['meeting-update'],
          text: '編輯全廠的議事',
        },
        {
          value: ['meeting-destroy-owner'],
          text: '刪除我負責的議事',
        },
        {
          value: ['meeting-destroy'],
          text: '刪除全廠的議事',
        },
        {
          value: ['meeting-export-read'],
          text: '瀏覽匯出紀錄',
        },
        {
          value: ['meeting-export-create'],
          text: '新增匯出紀錄',
        },
        {
          value: ['meeting-export-update'],
          text: '編輯匯出紀錄',
        },
      ],
    },
    meetingTemplate: {
      type: 'checkbox',
      label: '議事範本',
      multipleValue: true,
      items: [
        {
          value: ['meeting-template-read'],
          text: '瀏覽議事範本',
        },
        {
          value: ['meeting-template-create'],
          text: '新增議事範本',
        },
        {
          value: ['meeting-template-update'],
          text: '編輯議事範本',
        },
        {
          value: ['meeting-template-destroy'],
          text: '刪除議事範本',
        },
      ],
    },
    factorySystemClass: {
      type: 'checkbox',
      label: '自訂領域',
      multipleValue: true,
      items: [
        {
          value: ['factory-system-class-read'],
          text: '瀏覽自訂領域管理介面',
        },
        {
          value: ['factory-system-class-create'],
          text: '新增自訂領域',
        },
        {
          value: ['factory-system-class-update'],
          text: '編輯自訂領域',
        },
        {
          value: ['factory-system-class-destroy'],
          text: '刪除自訂領域',
        },
      ],
    },
    log: {
      type: 'checkbox',
      label: '操作記錄管理',
      multipleValue: true,
      items: [
        {
          value: ['log-manage'],
          text: '操作記錄管理',
        },
      ],
    },
  },
  scopeFields: [
    "dashboard",
    "parentDashboard",
    "broadcast",
    "acts",
    "alert",
    "task",
    'taskTemplate',
    "contractor",
    "license",
    "training",
    "event",
    "contractorEnterRecord",
    "audit",
    "checklist",
    "commonChoice",
    "changeManagement",
    "memberManagement",
    "roleManagement",
    "factoryManagement",
    "sosRequest",
    "app",
    "factoryTag",
    "factoryEffect",
    "qrcode",
    "file",
    'agent',
    'guideline',
    'guidelineAdmin',
    'translation',
    'meeting',
    'meetingTemplate',
    'factorySystemClass',
    'log',
  ],
};
